<p-dialog
  [(visible)]="visible"
  (visibleChange)="visibleChange.emit($event)"
  style="padding: 0"
>
  <ng-template pTemplate="header">
    <!-- Header del Modal -->
    <div class="cp-header">
      <div class="cp-header-left">
        <mat-icon size="24">settings_ethernet</mat-icon>
        <h5 class="cp-subtitle">Envía un comando a un dispositivo GPS</h5>
      </div>
    </div>
  </ng-template>

  <!-- <p-toast position="top-right" key="toastCommandPanel"></p-toast>
  <p-confirmDialog
    [style]="{ width: '450px' }"
    rejectButtonStyleClass="p-button-text"
  ></p-confirmDialog> -->

  <!-- Body con dos columnas -->
  <div class="cp-body">
    <!-- COLUMNA IZQUIERDA: Formulario -->
    <div class="cp-left-col">
      <!-- 1. Protocolo -->
      <div class="cp-form-section">
        <label class="cp-step-label">
          <span class="cp-step-num">1</span>
          Selecciona el protocolo del dispositivo
        </label>
        <div class="p-field p-col-12 pt-3">
          <p-selectButton
            [options]="protocols"
            [(ngModel)]="protocol"
            optionLabel="label"
            (ngModelChange)="onChangeProtocol()"
          >
            <ng-template let-item>
              <div
                *ngIf="item.value != 'cipia'"
                class="d-flex gap-2 align-items-center"
              >
                <mat-icon size="18" class="cp-dd-text">memory</mat-icon>
                <span style="font-size: 10px">{{ item.label }}</span>
              </div>
              <div
                *ngIf="item.value == 'cipia'"
                class="d-flex gap-2 align-items-center"
              >
                <svg
                  width="16"
                  height="16"
                  class="cp-dd-text"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M4.5 5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M3 4.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
                  />
                  <path
                    d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H8.5v3a1.5 1.5 0 0 1 1.5 1.5h5.5a.5.5 0 0 1 0 1H10A1.5 1.5 0 0 1 8.5 14h-1A1.5 1.5 0 0 1 6 12.5H.5a.5.5 0 0 1 0-1H6A1.5 1.5 0 0 1 7.5 10V7H2a2 2 0 0 1-2-2zm1 0v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1m6 7.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5"
                  />
                </svg>
                <span style="font-size: 10px">{{ item.label }}</span>
              </div>
            </ng-template>
          </p-selectButton>
        </div>
      </div>

      <!-- 2. Unidad -->
      <div class="cp-form-section">
        <label class="cp-step-label">
          <span class="cp-step-num">2</span>
          Selecciona una o múltiple unidades
        </label>
        <div class="p-field p-col-12 pt-3">
          <app-unit-filter
            [units]="_units"
            (leakedIMEIs)="onLeakedIMEIs($event)"
            [onClean]="onCleanUnitsFliter"
            [disabled]="!protocol?.value"
          ></app-unit-filter>
        </div>
        <div class="p-field p-col-12 pt-3">
          <span class="p-float-label">
            <p-multiSelect
              [options]="units"
              [(ngModel)]="selectedUnits"
              optionLabel="label"
              selectedItemsLabel="{0} unidades seleccionadas"
              maxSelectedLabels="2"
              resetFilterOnHide="true"
              scrollHeight="250px"
              [style]="{ width: '100%' }"
              panelStyleClass="cp-dropdown-panel"
              styleClass="cp-dropdown-panel"
              [disabled]="!protocol?.value"
            >
              <ng-template let-item pTemplate="item">
                <div
                  class="d-flex gap-2 justify-content-start align-items-center"
                >
                  <span>
                    <mat-icon
                      *ngIf="!item.imei.startsWith('E')"
                      size="18"
                      class="cp-dd-text"
                      >memory</mat-icon
                    >
                    <svg
                      *ngIf="item.imei.startsWith('E')"
                      width="16"
                      height="16"
                      class="cp-dd-text"
                      fill="currentColor"
                      viewBox="0 0 16 16"
                    >
                      <path
                        d="M4.5 5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M3 4.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
                      />
                      <path
                        d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H8.5v3a1.5 1.5 0 0 1 1.5 1.5h5.5a.5.5 0 0 1 0 1H10A1.5 1.5 0 0 1 8.5 14h-1A1.5 1.5 0 0 1 6 12.5H.5a.5.5 0 0 1 0-1H6A1.5 1.5 0 0 1 7.5 10V7H2a2 2 0 0 1-2-2zm1 0v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1m6 7.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5"
                      />
                    </svg>
                  </span>
                  <div class="cp-dd-item">{{ item.label }}</div>
                  <div
                    [style.color]="item.transmissionColor"
                    [style.border]="'1px solid ' + item.transmissionColor"
                    [style.borderRadius]="'4px'"
                    [style.padding]="'0px 4px'"
                    [style.fontSize]="'8px'"
                    [style.display]="'inline-block'"
                    [style.width]="'fit-content'"
                    [style.height]="'fit-content'"
                  >
                    {{ item.time }}
                    <!-- {{ item.transmissionName }} -->
                  </div>
                </div>
              </ng-template>
            </p-multiSelect>
            <label
              for="multiselect"
              style="color: #374151"
              [style.opacity]="!protocol?.value ? 0.6 : 1"
              >Seleccione las unidades</label
            >
          </span>
        </div>
      </div>

      <!-- 3. Comando -->
      <div class="cp-form-section">
        <label class="cp-step-label">
          <span class="cp-step-num">3</span>
          Selecciona un comando de la lista
        </label>

        <!-- Comandos Disponibles -->
        <div class="cp-section">
          <div class="cp-section-header">
            <p-dropdown
              [options]="filteredCommands"
              [(ngModel)]="selectedCommand"
              (onChange)="onCommandChange($event)"
              optionLabel="description"
              [placeholder]="selectedCommand ? selectedCommand.value : ''"
              [showClear]="true"
              [filter]="true"
              filterBy="value,description"
              emptyFilterMessage="No se encontraron resultados"
              emptyMessage="No hay comandos disponibles"
              [style]="{ width: '100%' }"
              class="w-100"
              panelStyleClass="cp-dropdown-panel"
              appendTo="body"
              autoWidth="false"
              [disabled]="true"
            >
              <ng-template let-item pTemplate="item">
                <div class="cp-dd-command-item">
                  <code class="cp-dd-command-value">{{
                    item.description
                  }}</code>
                  <span class="cp-dd-command-desc">{{ item.value }}</span>
                </div>
              </ng-template>
            </p-dropdown>
            <div class="d-flex gap-0 align-items-center">
              <button
                type="button"
                class="cp-refresh-btn"
                (click)="refreshCommands()"
                title="Actualizar lista"
              >
                <svg
                  viewBox="0 0 24 24"
                  width="18"
                  height="18"
                  stroke="currentColor"
                  stroke-width="2"
                  fill="none"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <polyline points="23 4 23 10 17 10"></polyline>
                  <polyline points="1 20 1 14 7 14"></polyline>
                  <path
                    d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"
                  ></path>
                </svg>
              </button>
              <button
                *ngIf="selectedCommand"
                type="button"
                class="cp-refresh-btn"
                (click)="clearCommandSelection()"
                title="Limpiar comando seleccionado"
              >
                <mat-icon>clear</mat-icon>
              </button>
            </div>
          </div>

          <!-- Search -->
          <div class="cp-search">
            <svg
              class="cp-search-icon"
              viewBox="0 0 24 24"
              width="16"
              height="16"
              stroke="currentColor"
              stroke-width="2"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <circle cx="11" cy="11" r="8"></circle>
              <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
            </svg>
            <input
              type="text"
              class="cp-search-input"
              [(ngModel)]="commandPromptSearch"
              (input)="searchCommand()"
              placeholder="Buscar comando..."
            />
          </div>

          <!-- Lista de comandos -->
          <div class="cp-command-list cp-list" *ngIf="loadingCommands">
            <ng-container *ngIf="filteredCommands.length > 0; else noCmds">
              <div
                class="cp-command-item"
                *ngFor="let cmd of availableCommands"
                [class.cp-active]="selectedCommand?.value === cmd.value"
                (click)="!cmd.disabled && selectCommand(cmd)"
                [disabled]="cmd.disabled"
                [style.opacity]="cmd.disabled ? '0.5' : '1'"
                [style.cursor]="cmd.disabled ? 'not-allowed' : 'pointer'"
              >
                <div class="cp-command-info">
                  <div
                    class="d-flex gap-2 justify-content-start align-items-center"
                  >
                    <code class="cp-command-value" style="font-size: small">{{
                      cmd.description
                    }}</code>
                    <div
                      class="d-flex justify-content-start align-items-start flex-column"
                    >
                      <span
                        style="opacity: 0.5"
                        style="
                          font-size: 8px;
                          font-weight: 600;
                          font-variant: small-caps;
                        "
                        >{{ cmd.protocol }}</span
                      >
                      <span *ngIf="cmd.disabled" class="badge-disabled">
                        DESHABILITADO
                      </span>
                    </div>
                  </div>
                  <span class="cp-command-desc" style="font-size: 8px">{{
                    cmd.value
                  }}</span>
                </div>
                <!-- <button
                  type="button"
                  class="cp-copy-btn"
                  (click)="
                    !cmd.disabled && copyCommandToClipboard(cmd);
                    $event.stopPropagation()
                  "
                  title="Copiar comando"
                  [disabled]="cmd.disabled"
                  [style.opacity]="cmd.disabled ? '0.5' : '1'"
                  [style.cursor]="cmd.disabled ? 'not-allowed' : 'pointer'"
                >
                  <svg
                    viewBox="0 0 24 24"
                    width="16"
                    height="16"
                    stroke="currentColor"
                    stroke-width="2"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <rect
                      x="9"
                      y="9"
                      width="13"
                      height="13"
                      rx="2"
                      ry="2"
                    ></rect>
                    <path
                      d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"
                    ></path>
                  </svg>
                </button> -->
              </div>
            </ng-container>
            <ng-template #noCmds>
              <div class="cp-empty">
                <svg
                  viewBox="0 0 24 24"
                  width="32"
                  height="32"
                  stroke="currentColor"
                  stroke-width="1.5"
                  fill="none"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path
                    d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"
                  ></path>
                  <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
                  <line x1="12" y1="22.08" x2="12" y2="12"></line>
                </svg>
                <p>No hay comandos disponibles</p>
              </div>
            </ng-template>
          </div>
          <div class="cp-loading-list" *ngIf="!loadingCommands">
            <svg
              class="cp-spinner"
              viewBox="0 0 24 24"
              width="24"
              height="24"
              stroke="currentColor"
              stroke-width="2.5"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M21 12a9 9 0 1 1-6.219-8.56"></path>
            </svg>
            <span>Cargando comandos...</span>
          </div>
        </div>
      </div>

      <!-- Botones -->
      <div class="cp-actions">
        <button
          type="button"
          class="cp-btn cp-btn-secondary"
          (click)="clearSelection()"
        >
          <svg
            viewBox="0 0 24 24"
            width="18"
            height="18"
            stroke="currentColor"
            stroke-width="2"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <polyline points="3 6 5 6 21 6"></polyline>
            <path
              d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"
            ></path>
          </svg>
          Limpiar
        </button>
        <button
          type="button"
          class="cp-btn cp-btn-primary"
          (click)="sendCommand()"
          [disabled]="
            !selectedCommand ||
            !protocol ||
            selectedUnits.length === 0 ||
            sendingCommand
          "
          [class.cp-loading]="sendingCommand"
        >
          <span *ngIf="!sendingCommand" class="cp-btn-content">
            <svg
              viewBox="0 0 24 24"
              width="18"
              height="18"
              stroke="currentColor"
              stroke-width="2"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <line x1="22" y1="2" x2="11" y2="13"></line>
              <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
            </svg>
            Enviar Comando
          </span>
          <span *ngIf="sendingCommand" class="cp-btn-loading">
            <svg
              class="cp-spinner"
              viewBox="0 0 24 24"
              width="18"
              height="18"
              stroke="currentColor"
              stroke-width="2.5"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M21 12a9 9 0 1 1-6.219-8.56"></path>
            </svg>
            Enviando...
          </span>
        </button>
      </div>
    </div>

    <!-- COLUMNA DERECHA: Lista de comandos + Respuesta -->
    <div class="cp-right-col">
      <!-- Respuesta Reciente -->
      <div class="cp-section cp-response cp-list" *ngIf="responses">
        <div class="cp-section-header cp-response-header">
          <h3 class="cp-section-title">Respuestas: {{ responses.length }}</h3>
          <button
            *ngIf="responses.length > 0"
            type="button"
            class="cp-refresh-btn"
            (click)="clearResponses()"
            title="Limpiar respuestas"
          >
            <mat-icon size="16">clear</mat-icon>
          </button>
        </div>
        <div
          class="cp-list"
          *ngIf="responses.length > 0; else noResp"
          style="max-height: 680px; overflow-y: auto"
        >
          <div *ngFor="let resp of responses">
            <div
              class="cp-response-card"
              [style.borderLeft]="
                resp?.query?.color ? '3px solid ' + resp?.query?.color : '0'
              "
              [style.backgroundColor]="
                resp?.query?.background ? resp?.query?.background : 'white'
              "
            >
              <div
                class="cp-response-main"
                (click)="showFullResponse = !showFullResponse"
              >
                <div class="cp-response-content">
                  <div
                    class="cp-response-title d-flex gap-1 align-items-center"
                  >
                    {{ resp?.query?.plate || "unknown" }}
                    <span class="cp-command-info">
                      <span
                        class="cp-command-value"
                        [style.color]="resp?.query?.color"
                        >{{ resp?.query?.payload || "unknown" }}</span
                      >
                    </span>
                    <span style="font-size: 8px">{{
                      resp?.query?.timestamp || resp?.timestamp
                    }}</span>
                  </div>
                  <div class="cp-response-sub gap-1 align-items-start">
                    <span style="font-size: 8px">{{
                      resp?.query?.message || "-"
                    }}</span>
                  </div>
                  <span style="font-size: 8px">{{
                    resp?.response?.message || "-"
                  }}</span>
                </div>
              </div>
            </div>

            <!-- Respuesta completa expandible -->
            <!-- <div class="cp-full-response" *ngIf="showFullResponse">
              <div
                class="cp-full-header"
                (click)="showFullResponse = !showFullResponse"
              >
                <span>Ver respuesta completa</span>
                <svg
                  class="cp-expand-icon"
                  [class.cp-rotated]="showFullResponse"
                  viewBox="0 0 24 24"
                  width="14"
                  height="14"
                  stroke="currentColor"
                  stroke-width="2"
                  fill="none"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <polyline points="6 9 12 15 18 9"></polyline>
                </svg>
              </div>
              <pre class="cp-json-pre" *ngIf="response?.response">{{
                response?.response | json
              }}</pre>
              <pre class="cp-json-pre" *ngIf="!response?.response">
    Sin respuesta detallada</pre
              >
            </div> -->
          </div>
        </div>
        <ng-container #noResp> </ng-container>
      </div>

      <!-- Placeholder sin respuesta -->
      <div class="cp-section cp-response-placeholder" *ngIf="!response">
        <div class="cp-empty">
          <svg
            viewBox="0 0 16 16"
            width="32"
            height="32"
            stroke="currentColor"
            stroke-width="1.5"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path
              d="M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-2.5a2 2 0 0 0-1.6.8L8 14.333 6.1 11.8a2 2 0 0 0-1.6-.8H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2.5a1 1 0 0 1 .8.4l1.9 2.533a1 1 0 0 0 1.6 0l1.9-2.533a1 1 0 0 1 .8-.4H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"
            />
          </svg>
          <p>No hay respuestas recientes</p>
          <span>Envía un comando para ver la respuesta aquí</span>
        </div>
      </div>
    </div>
  </div>
</p-dialog>
